import axios from 'axios';

export default function () {
  const newsletterForm = document.querySelector('#footer-newsletter-form');
  const newsletterSuccessMessage = document.querySelector('#footer-newsletter-form-success-message');
  const newsletterErrorMessage = document.querySelector('#footer-newsletter-form-error-message');
  const newsletterFormSubmit = document.querySelector('#newsletter-form-submit');

  if (!newsletterForm) return;

  newsletterForm.addEventListener('submit', (event) => {
    event.preventDefault();

    newsletterFormSubmit.setAttribute('disabled', 'disabled');

    axios.postForm('/actions/website/contact/create-contact', new FormData(newsletterForm))
      .then((result) => {
        newsletterFormSubmit.removeAttribute('disabled');
        if (result.data.success) {
          newsletterForm.classList.add('hidden');
          newsletterErrorMessage.classList.add('hidden');
          newsletterSuccessMessage.classList.remove('hidden');
        } else {
          newsletterErrorMessage.classList.remove('hidden');
        }
      })
      .catch(() => {
        newsletterFormSubmit.removeAttribute('disabled');
        newsletterErrorMessage.classList.remove('hidden');
      });
  });
}
